import React from "react";
import Switch from "@material-ui/core/Switch";
import { Formik, Form } from "formik";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import Swal from "sweetalert2";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import useAppStore from "../../../store/appStore";
import { useUpdateUser } from "../../../hooks/useUpdateUser";
import { useSyncStrapi } from "../../../hooks/useSyncStrapi";
import { RolesTypes } from '../../../constants/roles';

const UserSettings = () => {
  const userData = useAppStore(state => state.user?.me);
  const updateUserMutation = useUpdateUser();
  const { mutate: updateUser, isPending } = updateUserMutation;
  const { mutate: syncStrapi, isPending: isSyncPending } = useSyncStrapi();

  const startSyncStrapi = () => {
    syncStrapi(undefined, {
      onSuccess: () => {
        Swal.fire({
          type: "success",
          title: "Saved",
          showConfirmButton: false,
          text: "Strapi updated with success",
          timer: 1500
        });
      },
      onError: error => {
        Swal.fire({
          type: "error",
          title: "Error",
          text: "Failed to update Strapi contents",
          showConfirmButton: true
        });
      }
    });
  };

  if (!userData) return <LoadingSpinner styles={{ paddingTop: 60 }} />;

  return (
    <Formik
      initialValues={{
        privacyPolicy: userData.privacyPolicy,
        profileScorecard: userData.profileScorecard,
        publishAchievement: userData.publishAchievement
      }}
      validate={values => {
        const errors = {};
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        updateUser(values, {
          onSuccess: () => {
            setSubmitting(false);
            Swal.fire({
              type: "success",
              title: "Saved",
              showConfirmButton: false,
              timer: 1500
            });
          },
          onError: error => {
            setSubmitting(false);
            Swal.fire({
              type: "error",
              title: "Error",
              text: "Failed to save settings",
              showConfirmButton: true
            });
          }
        });
      }}
    >
      {({ values, handleChange, isSubmitting }) => (
        <Form>
          <div className="row">
            <div className="col-md-6 d-flex align-self-stretch">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Notification: </h5>
                </div>
                <div className="card-body">
                  <h5>
                    Challenge to do
                    <Switch
                      className="float-right"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </h5>
                  <br />
                  <h5>
                    Demopath to do
                    <Switch
                      className="float-right"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </h5>
                  <br />
                  <h5>
                    Messages from Coach
                    <Switch
                      className="float-right"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </h5>
                  <br />
                  <h5>
                    Messages from School
                    <Switch
                      className="float-right"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </h5>
                  <br />
                  <h5>
                    Complete profile
                    <Switch
                      className="float-right"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Privacy Policy: </h5>
                </div>
                <div className="card-body">
                  <h5>
                    <a
                      href="https://gamsplatform.com/privacy-policy/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      System privacy policy
                    </a>
                    <Switch
                      className="float-right"
                      name="privacyPolicy"
                      value={values.privacyPolicy}
                      checked={values.privacyPolicy}
                      onChange={handleChange}
                    />
                  </h5>
                </div>
              </div>

              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Profile Scorecard: </h5>
                </div>
                <div className="card-body">
                  <h5>
                    Share my profile scorecard with recruiters
                    <Switch
                      className="float-right"
                      name="profileScorecard"
                      value={values.profileScorecard}
                      checked={values.profileScorecard}
                      onChange={handleChange}
                    />
                  </h5>
                </div>
              </div>

              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Publish your achievement</h5>
                </div>
                <div className="card-body">
                  <h5>
                    Share your results
                    <Switch
                      className="float-right"
                      name="publishAchievement"
                      value={values.publishAchievement}
                      checked={values.publishAchievement}
                      onChange={handleChange}
                    />
                  </h5>
                </div>
              </div>
              { userData.userRole === RolesTypes.SUPERUSER && <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Strapi Contents</h5>
                </div>
                <div className="card-body">
                  <h5>
                    Click the button to update the contents
                    <span className="float-right">
                      {isSyncPending && <LoadingSpinner />}
                      {!isSyncPending && (
                        <Button
                          className="btn btn-fill btn-rose"
                          type="button"
                          variant="contained"
                          size="large"
                          onClick={() => startSyncStrapi()}
                          disabled={isSubmitting || isSyncPending}
                        >
                          Update
                        </Button>
                      )}
                    </span>
                  </h5>
                </div>
              </div>}
            </div>
          </div>
          <div className="row" style={{ justifyContent: "center" }}>
            {isPending && <LoadingSpinner />}
            {!isPending && (
              <Button
                className="btn btn-fill btn-rose"
                type="submit"
                variant="contained"
                size="large"
                disabled={isSubmitting || isPending}
              >
                <SaveIcon />
                Save
              </Button>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default UserSettings;
